export const MODULE_NAME = 'views/cottage-list'

export const COTTAGE_LIST_MAP_ROUTE_NAME = 'cottage-list-map'
export const COTTAGE_LIST_LIST_ROUTE_NAME = 'cottage-list-list'
